var React = require('react');

function ArrowDownIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.8 1C6.8 0.558172 6.44183 0.2 6 0.2C5.55817 0.2 5.2 0.558172 5.2 1L6.8 1ZM5.43432 12.5657C5.74673 12.8781 6.25327 12.8781 6.56569 12.5657L11.6569 7.47452C11.9693 7.1621 11.9693 6.65557 11.6569 6.34315C11.3444 6.03073 10.8379 6.03073 10.5255 6.34315L6 10.8686L1.47452 6.34315C1.1621 6.03073 0.655565 6.03073 0.343146 6.34315C0.0307267 6.65557 0.0307267 7.1621 0.343146 7.47452L5.43432 12.5657ZM5.2 1L5.2 12L6.8 12L6.8 1L5.2 1Z","fill":"current"}));
}

ArrowDownIconInline.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = ArrowDownIconInline;

ArrowDownIconInline.default = ArrowDownIconInline;
